import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `Inicio del chat anónimo de ${ctx.brand}`,
    languageButtonLabel: `Idioma`,
    languageModalTitle: `Elige idioma`,
    languageModalCloseLabel: `Cerrar menú de idiomas`,
  },
  languageOptions: {
    'en-US': {
      label: `Inglés (Estados Unidos)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Inglés (Kenia)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Inglés (Nigeria)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Inglés (Singapur)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Portugués (Portugal)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Portugués (Brasil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Alemán (Alemania)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Alemán (Austria)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Alemán (Suiza)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Español (España)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Francés (Francia)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Italiano (Italia)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Neerlandés (Países Bajos)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polaco (Polonia)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Sueco (Suecia)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Danés (Dinamarca)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Finés (Finlandia)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Noruego (Noruega)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Islandés (Islandia)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Japonés (Japón)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Coreano (Corea del Sur)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Chino (China)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Cantonés (RAE de Hong Kong (China))`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Vietnamita (Vietnam)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Tailandés (Tailandia)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Indonesio (Indonesia)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Suajili (Kenia)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Hindi (India)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `Bengalí (Bangladés)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `Maratí (India)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `Telugu (India)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Persa (Irán)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `Urdu (Pakistán)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `Punyabí (Pakistán)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Pidgin de Nigeria (Nigeria)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Ruso (Rusia)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Árabe (Arabia Saudí)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `Árabe (Emiratos Árabes Unidos)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `Árabe (Catar)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Árabe marroquí (Marruecos)`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Turco (Turquía)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Elige idioma`,
    closeLabel: `Cerrar menú de idiomas`,
  },
  languageHint: (ctx) => `Salta entre más de ${ctx.localesCount}+ idiomas sin crear cuenta.`,
  readPagePrompt: ({languageLabel}) => `Lee esta página en ${languageLabel}.`,
};
